module.exports = __webpack_public_path__ + "img/shipinhao.7a6adf8e.jpg";